import * as yup from 'yup';

export const bookingCommentsInitialValues = {
  bookingComments: '',
};

export const validationSchema = yup.object().shape({
  bookingComments: yup.string().required('Booking comments are required'),
});
